import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Dropdown } from 'semantic-ui-react'

function TacticObjective({ selectedBrand, onSelectTactics, selectedTactics, onSelectPurpose, selectedPurpose }) {
	if(!selectedBrand) return <h3 className='text-center'>You must select a brand first</h3>

	const objectivesDropdown = selectedBrand.purpose_categories.map((objective, i) => ({
		key: objective.category_name + i,
		value: objective.category_name,
		text: objective.category_name,
	}))

	const tacticsDropdown = selectedBrand.tactical_categories.map((tactic, i) => ({
		key: tactic.category_name + i,
		value: tactic.category_name,
		text: tactic.category_name,
	}))

	// const businessCardQuestionsDropdown = selectedBrand.businessCardQuestions.map((questionGroup, i) => ({
	// 	key: questionGroup.tag_name + i,
	// 	value: questionGroup,
	// 	text: questionGroup.tag_name,
	// }))

	return (
		<Row>
			<Col>
				<div className='mb-4'>
					<h6>Tactics</h6>
					<Dropdown
						clearable
						search
						selection
						multiple
						placeholder='Select Tactics'
						className='w-100'
						name='tactics'
						options={tacticsDropdown}
						value={selectedTactics}
						onChange={(e, { name, value }) => onSelectTactics(value)}
					/>
				</div>
			</Col>
			<Col>
				<div className='mb-4'>
					<h6>Objective</h6>
					<Dropdown
						clearable
						search
						selection
						placeholder='Select Objective'
						className='w-100'
						name='purpose'
						options={objectivesDropdown}
						value={selectedPurpose}
						onChange={(e, { name, value }) => onSelectPurpose(value)}
					/>
				</div>
			</Col>
			{/*<Col>
				<div className='mb-4'>
					<h6>Business Card Questions</h6>
					<Dropdown
						clearable
						search
						selection
						placeholder='Select Question Group'
						className='w-100'
						name='business_card_questions'
						options={businessCardQuestionsDropdown}
						value={gigState.business_card_questions}
						onChange={(e, { name, value }) => onInputChange(name, value)}
					/>
				</div>
			</Col>*/}
			{/*<Col>
				<h6>Additional Questions</h6>
			</Col>*/}
		</Row>
	)
}

export default TacticObjective
